module.exports = __webpack_public_path__ + "img/download on playstore.e624fc40.png";